import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { E5coreUiWorkAttachmentsBaseComponent } from './e5core-ui-work-attachments-base';
import { PageEvent, MatSort, MatPaginator } from '@angular/material';
import { AttachmentsOdataService } from '../../../services/attachments-odata.service';
import { Guid } from 'guid-typescript';
import { OdataMatTableDataSource } from './odata-mat-table-data-source';
import { WorkItemModel } from '../../../models/work-item';
import { FileUploadModel } from '../../../models/file-upload.model';
import { ViewerDisplayEvent } from '../../../events/viewer-display-event';

@Component({
  selector: 'e5core-ui-work-attachments-material',
  templateUrl: './e5core-ui-work-attachments-material.component.html',
  styleUrls: ['./e5core-ui-work-attachments-material.component.css']
})
export class E5coreUiWorkAttachmentsMaterialComponent extends E5coreUiWorkAttachmentsBaseComponent implements OnInit{

  @Input() workItem$ : BehaviorSubject<WorkItemModel>;
  @Input() fileUpload$: BehaviorSubject<FileUploadModel>;
  
  @Output() attachmentDownloadEvent = new EventEmitter();
  @Output() attachmentSelectEvent = new EventEmitter<ViewerDisplayEvent>();

  displayedColumns: string[] = ['Select','Menu','Name','Type'];
  dataSource: OdataMatTableDataSource ;
  isLoading: boolean = true ;

  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] ;

  // MatPaginator Output
  pageEvent: PageEvent;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private workAttachments : AttachmentsOdataService) {
    super() ;
  }

  ngOnInit() {
    this.pageSizeOptions = (this.pagesizes && this.pagesizes.length > 0) ? this.pagesizes : [5, 10, 25, 50];
    this.dataSource = new OdataMatTableDataSource(Guid.EMPTY, this.workAttachments); // this.history.getHistory(id, 0, 10) ;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.loadingEvents.subscribe(
      isLoading => {
        this.isLoading = isLoading ;
      }
    )

    if (typeof this.workItem$ != 'undefined') {
      this.workItem$.subscribe(
        wim => {
          this.dataSource.setWorkId(wim.workId) ;
        }
      )
    }
  
    if (typeof this.fileUpload$ != 'undefined') {
      this.fileUpload$.subscribe(
        fum => {
          this.dataSource.setWorkId(fum.workId) ;
        }
      )
    }
  }

  refresh() {
    this.dataSource.update();
  }

  onAttachmentDownload(event, element) {

    this.attachmentDownloadEvent.emit({ event:event, element: element });
  }

  onAttachmentSelect(event, element) {
    this.attachmentSelectEvent.emit({workId: element.WorkId, type: "E5SharepointAttachment", attachmentId: element.Id, fullUrl: null, name: null});
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }
}